<template>
  <router-view style="padding: 0 24px"></router-view>
</template>

<script>
export default {
  data() {
    return {
      test: null,
    };
  },
};
</script>
